import { render, staticRenderFns } from "./AvContractControlRightsForm.vue?vue&type=template&id=12fa4e79&"
import script from "./AvContractControlRightsForm.vue?vue&type=script&lang=js&"
export * from "./AvContractControlRightsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AvContractControlRightsForm.vue"
export default component.exports